import { Button, Form, Input, Skeleton, notification } from "antd";
import { API_URL } from "env";
import { useEffect, useState } from "react";

const PermissionEditModal = ({ id, onClose }: { id: string[]; onClose: () => void }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [api, contextHolder] = notification.useNotification();

    useEffect(() => {
        if (!id?.length) return;
        async function fetchPermissionDetails() {
            setLoading(true);
            try {
                const response = await fetch(`${API_URL}api/v1/be/permission/${id[0]}`, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
                });
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();
                form.setFieldsValue({
                    permissionName: data.data.display_name || '',
                    module: data.data.module || '',
                    description: data.data.description || '',
                });
            } catch (error) {
                console.error('Error fetching permission details:', error);
            } finally {
                setLoading(false);
            }
        }
        fetchPermissionDetails();
    }, [id, form]);

    async function handleSubmit(values: { permissionName: string; module: string; description: string }) {
        setSaving(true);
        try {
            for (const permId of id) {
                const response = await fetch(`${API_URL}api/v1/be/permission/${permId}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                    body: JSON.stringify({
                        display_name: values.permissionName,
                        module: values.module,
                        description: values.description,
                    }),
                });
                if (!response.ok) throw new Error('Network response was not ok');
            }
            api.success({ message: 'Permission updated', placement: 'topRight' });
            onClose();
        } catch (error) {
            api.error({ message: 'Failed to update permission', placement: 'topRight' });
        } finally {
            setSaving(false);
        }
    }

    return (
        <>
            {contextHolder}
            {loading ? (
                <Skeleton active paragraph={{ rows: 4 }} />
            ) : (
                <Form form={form} layout="vertical" onFinish={handleSubmit}>
                    <Form.Item name="permissionName" label="Display Name" rules={[{ required: true, message: 'Required' }]}>
                        <Input placeholder="Enter display name" />
                    </Form.Item>
                    <Form.Item name="module" label="Module">
                        <Input placeholder="Enter module name" />
                    </Form.Item>
                    <Form.Item name="description" label="Description">
                        <Input.TextArea placeholder="Enter description" rows={3} />
                    </Form.Item>
                    <div className="text-xs text-text-muted mb-4">
                        Affected IDs: {id.join(', ')} · Action field is not editable
                    </div>
                    <div className="flex justify-end gap-2 pt-2 border-t border-border">
                        <Button onClick={onClose}>Cancel</Button>
                        <Button type="primary" htmlType="submit" loading={saving}>Save Changes</Button>
                    </div>
                </Form>
            )}
        </>
    );
};

export default PermissionEditModal;
